'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openModal = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('scripts/components/Overlay/handlers');

var _handlers2 = require('scripts/components/Scroll/handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lastFocus;
var modalOpened;

var openModal = exports.openModal = function openModal() {
  if ($(_Dom2.default.mailChimpModal).length > 0) {
    $(_Dom2.default.mailChimpModal).addClass('is-active');
    modalOpened = true;
    (0, _handlers.showOverlay)();
    (0, _handlers2.scrollLock)();
    lastFocus = document.activeElement; //Stores focused element before modal opens

    $(document).on('keydown', function (event) {
      if (event.which === 27 && modalOpened) {
        event.preventDefault();
        closeModal();
      }
    });
  }
};

var mc1Submitted = false;
$('#mc-embedded-subscribe-form').on('submit reset', function (event) {
  if ("submit" === event.type) {
    setTimeout(function () {
      closeModal();
    }, 3000);
  }
});

var closeModal = exports.closeModal = function closeModal() {
  if ($(_Dom2.default.mailChimpModal).length > 0) {
    $(_Dom2.default.mailChimpModal).removeClass('is-active');
    modalOpened = false;
    (0, _handlers.hideOverlay)();
    (0, _handlers2.scrollUnlock)();
    if (!modalOpened) {
      lastFocus.focus(); // Return focus to the last focused element before modal opened
    }
  }
};